module.exports = __webpack_public_path__ + "static/assets/4a528d3de55bec9983bd0eb39777143b.png";